import Education from '@/apps/Education'
import Layout from '@/apps/layout/components'
import React from 'react'

const EducationPage = (): React.ReactElement => {
  return (
    <Layout>
      <Education />
    </Layout>
  )
}

export default EducationPage
